import { TOGGLE_SIDEBAR } from './Types'

// Register User
export const toggleSidebar = (data) => (dispatch) => {
  dispatch({
    type: TOGGLE_SIDEBAR,
    payload: data,
  })
}
